export class validityExntension {
    id: number;
    comments: string;
    created: string;
    pkgId: number;
    requestedBy: string;
    requestedDate: string;
    subId: number;
    updatedBy: string;
    validityExt: number;
}